<div
    class="t-dialog-content"
    @tuiSlideInTop
>
    <!-- TODO: Polymorpheus fix type -->
    <ng-container *polymorpheusOutlet="$any(context.content) as text; context: context">
        {{ text }}
    </ng-container>
</div>
